export enum ObservationBundleCategory {
  AT_HOME = "AT_HOME",
  SELF_TESTING = "SELF_TESTING",
  REGULAR = "REGULAR",
  IMPORTED = "IMPORTED",
  SELF_REPORTED = "SELF_REPORTED",
  EXCLUDED = "EXCLUDED",
  UNKNOWN = "UNKNOWN"
}

export interface ObservationBundle {
  identifier?: {
    system?: string;
    value?: string;
    type?: {
      coding?: Array<{ code?: string }>;
    };
  };
  entry?: Array<{
    resource?: {
      id?: string;
      resourceType?: string;
      effectiveDateTime?: string;
      performer?: Array<{
        identifier?: { system?: string; value?: string };
        display?: string;
        type?: string;
      }>;
      contained?: Array<{
        resourceType?: string;
        id?: string;
        intent?: string;
        orderDetail?: Array<{ text?: string }>;
      }>;
    };
  }>;
  timestamp?: string;
  link?: Array<{ url?: string }>;
}
